module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normala"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WHO’S WHO IN FILMS")])]), _vm._v(" "), _c('p', {
    staticClass: "blq-normala"
  }, [_vm._v("CIRAK (Ši’răk) JASON PETER")]), _vm._v(" "), _c('p', {
    staticClass: "blq-normala"
  }, [_vm._v("B. Rakovnik, Czechoslovakia, Feb. 11, 1919. Only son of Vanos & Anna Cirak. Fled to U.S. to escape Nazi persecution. Rose to sudden fame through award-winning documentary, "), _c('i', [_vm._v("The Refugees")]), _vm._v(", filmed with borrowed equipment and financed by working at odd jobs. Subsequent films included "), _c('i', [_vm._v("Soldier Boy")]), _vm._v(" (1948), "), _c('i', [_vm._v("Backhand")]), _vm._v(" (1952), "), _c('i', [_vm._v("Even So")]), _vm._v(" (1958), "), _c('i', [_vm._v("Crooked Mile")]), _vm._v(" (1965). None achieved success of earliest work. M. Marion Estes Plummer, member of a prominent eastern family, June 1, 1959. One dau. Jennifer Maria, b. Oct. 29, 1961. Present residence unknown.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06e1940b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 75
// module chunks = 0